module.exports = __webpack_public_path__ + "media/images/icons/icon-next-60b09b3b3e0a3d4a5fe91190db5ed5e7.svg";